




























































































import authType from '@/store/types/auth';
import { TeipNotifications } from '@/util/teipNotifications';
import Vue from 'vue';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'ResetPassword',
  data() {
    return {
      data: {
        password: '',
        password_confirmation: '',
        code: '',
      },
      rules: 'required|min:8|max:20|regex:^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#!@#$%^&*]).*$',
      // eslint-disable-next-line max-len
      rules2: 'confirmed:password|required|min:8|max:20|regex:^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#!@#$%^&*]).*$',
      loading: false,
    };
  },
  mounted() {
    this.$data.data.code = this.$route.params.id;
  },
  methods: {
    ...mapActions({
      resetPassword: `authModule/${authType.actions.RESET_PASSWORD}`,
    }),
    async reset() {
      this.$data.loading = true;
      const teipNotification = new TeipNotifications();
      try {
        await this.resetPassword(this.$data.data);
        teipNotification.success('Cambio de contraseña satisfactorio');
        await this.$router.push({
          name: 'Login',
        });
      } catch (err) {
        teipNotification.warning('Token Invalido');
      }
      this.$data.loading = false;
    },
  },
});
